import GoogleGeoCoderResponse from '../../../globalTypes/GoogleGeoCoderResponse';
var GoogleGeoCoder = /** @class */ (function () {
    //private googlePromise: Promise<object>;
    function GoogleGeoCoder() {
        /*
        const src = document.createElement('script');
        src.src = 's';
        src.async = false;

        const head = document.head || document.getElementsByTagName('head')[0];
        head.insertBefore(src, head.firstChild);
        this.googlePromise = new Promise((resolve, reject) => {
            src.addEventListener('load', () => {
                // @ts-ignore
                if (typeof window.google !== 'undefined') {
                    // @ts-ignore
                    resolve(window.google);
                }
                reject();
            });
            src.addEventListener('error', () => {
                reject();
            })
        });
        */
    }
    GoogleGeoCoder.getInstance = function () {
        if (GoogleGeoCoder.instance !== null) {
            return GoogleGeoCoder.instance;
        }
        return GoogleGeoCoder.instance = new GoogleGeoCoder();
    };
    GoogleGeoCoder.prototype.encode = function (country, postCode, name) {
        //const google:object = await this.googlePromise;
        var countryCode;
        switch (country) {
            case 'D':
                countryCode = 'DE';
                break;
            case 'AND':
                countryCode = 'AD';
                break;
            case 'B':
                countryCode = 'BE';
                break;
            case 'DK':
                countryCode = 'DK';
                break;
            case 'FIN':
                countryCode = 'FI';
                break;
            case 'F':
                countryCode = 'FR';
                break;
            case 'GB':
                countryCode = 'GB';
                break;
            case 'IRL':
                countryCode = 'IE';
                break;
            case 'I':
                countryCode = 'IT';
                break;
            case 'FL':
                countryCode = 'LI';
                break;
            case 'L':
                countryCode = 'LU';
                break;
            case 'NL':
                countryCode = 'NL';
                break;
            case 'N':
                countryCode = 'NO';
                break;
            case 'PL':
                countryCode = 'PL';
                break;
            case 'P':
                countryCode = 'PT';
                break;
            case 'S':
                countryCode = 'SE';
                break;
            case 'CH':
                countryCode = 'CH';
                break;
            case 'SK':
                countryCode = 'SK';
                break;
            case 'E':
                countryCode = 'ES';
                break;
            case 'CZ':
                countryCode = 'CZ';
                break;
            case 'A':
                countryCode = 'AT';
                break;
            default:
                countryCode = 'DE';
        }
        var response = new Promise(function (resolve, reject) {
            // @ts-ignore
            var geocoder = new google.maps.Geocoder();
            var isFR = location.pathname.includes('/fr/');
            geocoder.geocode({ address: countryCode + ',' + postCode, language: isFR ? 'fr' : 'de' }, function (results, status) {
                // @ts-ignore
                var stateOk = status === google.maps.GeocoderStatus.OK;
                var googleGeoCoderResponse = new GoogleGeoCoderResponse(stateOk ? 'OK' : 'NO', name);
                if (stateOk) {
                    var locality = results[0].address_components.filter(function (addressComponent) {
                        return addressComponent.types.includes('locality');
                    });
                    var countryName = results[0].address_components.filter(function (addressComponent) {
                        return addressComponent.types.includes('country');
                    });
                    var placeName = locality.length ? locality[0].long_name : '';
                    if (placeName !== '' && postCode !== '') {
                        googleGeoCoderResponse.addCity(postCode, placeName);
                    }
                    if (countryCode === countryName[0].short_name) {
                        resolve(googleGeoCoderResponse);
                    }
                }
                reject(false);
            });
        });
        return response;
    };
    GoogleGeoCoder.instance = null;
    return GoogleGeoCoder;
}());
export { GoogleGeoCoder };
